import { render, staticRenderFns } from "./AssessmentAccelerator.vue?vue&type=template&id=253a2028&scoped=true&"
import script from "./AssessmentAccelerator.vue?vue&type=script&lang=js&"
export * from "./AssessmentAccelerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253a2028",
  null
  
)

export default component.exports